import { defaultApiState } from "../api.state";

export default {
  GET_ADMIN_PERMISSIONS_LOADING(state) {
    state.apiState.getAdminPermissions = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADMIN_PERMISSIONS_SUCCESS(state, payload) {
    state.apiState.getAdminPermissions = {
      ...defaultApiState,
      success: true,
    };
    state.permissions = payload;
  },
  GET_ADMIN_PERMISSIONS_ERROR(state, error) {
    state.apiState.getAdminPermissions = {
      ...defaultApiState,
      error,
    };
  },

  GET_ADMIN_ROLES_LOADING(state) {
    state.apiState.getAdminRoles = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADMIN_ROLES_SUCCESS(state, payload) {
    state.apiState.getAdminRoles = {
      ...defaultApiState,
      success: true,
    };
    state.adminRoles = payload;
  },
  GET_ADMIN_ROLES_ERROR(state, error) {
    state.apiState.getAdminRoles = {
      ...defaultApiState,
      error,
    };
  },
  GET_ADMIN_ROLE_LOADING(state) {
    state.apiState.getAdminRole = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADMIN_ROLE_SUCCESS(state, payload) {
    state.apiState.getAdminRole = {
      ...defaultApiState,
      success: true,
    };
    state.adminRole = payload;
  },
  GET_ADMIN_ROLE_ERROR(state, error) {
    state.apiState.getAdminRole = {
      ...defaultApiState,
      error,
    };
  },
  ADD_ADMIN_ROLE_LOADING(state) {
    state.apiState.addAdminRole = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_ADMIN_ROLE_SUCCESS(state) {
    state.apiState.addAdminRole = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_ADMIN_ROLE_ERROR(state, error) {
    state.apiState.addAdminRole = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_ADMIN_ROLE_LOADING(state) {
    state.apiState.updateAdminRole = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_ADMIN_ROLE_SUCCESS(state) {
    state.apiState.updateAdminRole = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_ADMIN_ROLE_ERROR(state, error) {
    state.apiState.updateAdminRole = {
      ...defaultApiState,
      error,
    };
  },
  DELETE_ADMIN_ROLE_LOADING(state) {
    state.apiState.deleteAdminRole = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_ADMIN_ROLE_SUCCESS(state, payload) {
    state.apiState.deleteAdminRole = {
      ...defaultApiState,
      success: true,
    };
    state.adminRoles = state.adminRoles.filter((o) => o.id !== payload.id);
  },
  DELETE_ADMIN_ROLE_ERROR(state, error) {
    state.apiState.deleteAdminRole = {
      ...defaultApiState,
      error,
    };
  },
};
